import React from 'react';
import { Link } from 'react-router-dom';
import './landing.css';
import useDemosPage from './useDemosPage';
import openExternal from './openExternal';
import LogoMark from './art/LogoMark';

// Generated from the LegalApp design canvas. Class names carry the "dm-" prefix
// so they never collide with the rest of the app's CSS.
export default function DemosPage() {
  const {
    rootRef, videoSrc, poster, kicker, dur, title, desc,
    hasChapters, chapters, count, items,
  } = useDemosPage();
  return (
    <div className="dm-dm" ref={rootRef}>
      <header className="dm-nav">
        <div className="dm-wrap" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "20px", minHeight: "76px" }}>
          <Link to="/" style={{ display: "flex", alignItems: "center", gap: "12px", textDecoration: "none" }} aria-label="LegalApp home">
            <LogoMark />
            <span className="dm-d" style={{ fontSize: "24px", fontWeight: "700", letterSpacing: "-0.01em", color: "#0B1B3F" }}>
              {"Legal"}
              <span style={{ color: "#1D5BD8" }}>
                {"App"}
              </span>
            </span>
          </Link>
          <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
            <Link to="/" className="dm-back" aria-label="Back to home">
              <svg viewBox="0 0 24 24" style={{ width: "18px", height: "18px" }} aria-hidden="true">
                <path className="dm-ic" d="M19 12H5M11 6l-6 6 6 6" />
              </svg>
              <span>
                {"Back"}
                <span className="dm-hide-sm">
                  {" to home"}
                </span>
              </span>
            </Link>
            <a className="dm-btn" href="https://wa.me/919582822225?text=Hi%2C%20I%27d%20like%20to%20book%20a%20demo%20of%20LegalApp." target="_blank" rel="noopener noreferrer" onClick={openExternal} title="Book a demo on WhatsApp">
              {"Book a demo"}
            </a>
          </div>
        </div>
      </header>
      <section className="dm-hero">
        <div className="dm-wrap" style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
          <div className="dm-eyebrow" style={{ color: "#1D5BD8" }}>
            {"Demos"}
          </div>
          <h1 className="dm-d" style={{ fontSize: "clamp(42px, 6vw, 72px)", lineHeight: "1", fontWeight: "700", letterSpacing: "-0.02em", color: "#0B1B3F" }}>
            {"See LegalApp at work."}
          </h1>
          <p style={{ fontSize: "clamp(17px, 1.6vw, 20px)", color: "#5A6684", maxWidth: "640px" }}>
            {"Short walkthroughs, one feature at a time. Each demo takes an FIR and shows every step on screen, with captions."}
          </p>
        </div>
      </section>
      <section>
        <div className="dm-wrap dm-stage">
          <div className="dm-player-col" id="player">
            <div className="dm-phone">
              <video className="dm-player" controls playsInline preload="metadata" src={videoSrc} poster={poster} aria-label={title} />
            </div>
            <div className="dm-hint">
              {"Turn the sound on for the voice-over."}
            </div>
          </div>
          <div className="dm-info">
            <div className="dm-now" aria-live="polite">
              <div className="dm-kick dm-m">
                {kicker}{" · "}{dur}
              </div>
              <h2 className="dm-d">
                {title}
              </h2>
              <p>
                {desc}
              </p>
              {hasChapters && (
                <>
                  <div className="dm-lbl">
                    {"In this demo"}
                  </div>
                  <ol className="dm-chapters">
                    {chapters.map((c) => (
                        <li key={c.href}>
                          <a className="dm-chap" href={c.href} onClick={c.seek}>
                            <span className="dm-t">
                              {c.time}
                            </span>
                            <span>
                              {c.label}
                            </span>
                          </a>
                        </li>
                    ))}
                  </ol>
                </>
              )}
              <div className="dm-ctas">
                <a className="dm-btn" href="https://wa.me/919582822225?text=Hi%2C%20I%27d%20like%20to%20book%20a%20demo%20of%20LegalApp." target="_blank" rel="noopener noreferrer" onClick={openExternal} title="Book a demo on WhatsApp">
                  {"Book a live demo"}
                </a>
                <span className="dm-note">
                  {"Questions? "}
                  <a href="https://wa.me/919582822225" target="_blank" rel="noopener noreferrer" onClick={openExternal}>
                    {"WhatsApp +91 95828 22225"}
                  </a>
                </span>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
              <div className="dm-all">
                <h3 className="dm-d">
                  {"All demos"}
                </h3>
                <span className="dm-m dm-note">
                  {count}{" videos"}
                </span>
              </div>
              <div className="dm-grid">
                {items.map((item) => (
                    <a key={item.href} className={item.cls} href={item.href} onClick={item.select} aria-current={item.current}>
                      <span className="dm-thumb">
                        <img src={item.thumb} alt={item.alt} loading="lazy" width="640" height="360" />
                        <span className="dm-playing">
                          {"Now playing"}
                        </span>
                      </span>
                      <span className="dm-meta dm-m">
                        {item.kicker}{" · "}{item.dur}
                      </span>
                      <span className="dm-ttl dm-d">
                        {item.title}
                      </span>
                    </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="dm-foot" style={{ borderTop: "1px solid #DCE4F2", padding: "32px 0" }}>
        <div className="dm-wrap" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px 24px", fontSize: "14px", color: "#5A6684" }}>
          <span>
            {"© 2026 LexOnAlgo Advisory Pvt. Ltd. All rights reserved."}
          </span>
          <span style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
            <Link to="/">
              {"Home"}
            </Link>
            <Link to="/privacy">
              {"Privacy"}
            </Link>
            <Link to="/terms">
              {"Terms of Use"}
            </Link>
            <a href="mailto:contact@legalapp.in">
              {"contact@legalapp.in"}
            </a>
            <a href="https://wa.me/919582822225" target="_blank" rel="noopener noreferrer" onClick={openExternal}>
              {"Support"}
            </a>
          </span>
        </div>
      </footer>

    </div>
  );
}
